interface HelpCenterWindow extends Window {
    _elev?: {
        openModule?: (module: number) => void;
        setSettings?: (settings: { hideLauncher: boolean }) => void;
    };
}

declare const window: HelpCenterWindow;

const consoleElevioNotInitializedError = () => {
    console.error('Elevio help center is not initialized yet');
};

const openElevioModule = (module: number) => {
    const open = window._elev?.openModule;

    if (!open) {
        consoleElevioNotInitializedError();

        return;
    }

    open(module);
};

export const setElevioWidgetVisibility = (visible: boolean) => {
    const setSettings = window._elev?.setSettings;

    if (!setSettings) {
        consoleElevioNotInitializedError();

        return;
    }

    setSettings({
        hideLauncher: !visible,
    });
};

enum ElevioModules {
    ContactUs = 2,
}

export const openElevioContactUs = () => openElevioModule(ElevioModules.ContactUs);
